export let measurementDropDownListProps = {
    key: 0,
    id: 0,
    measurement_value: '',
    measurement_instruction_image: ''
}

export let measurementListProps = {
    sl_no: 0,
    id: 0,
    measurement_name: '',
    measurement_name_translation: '',
    measurement_value_fixed: false,//single-line, dropdown-list
    measurement_instruction_image: '',
    category_id_list: [],
    measurement_drop_down_list: [JSON.parse(JSON.stringify(measurementDropDownListProps))],
    deleted_measurement_drop_down_list_items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementMaster/properties.js